/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "fault_detectors";

/**
 * If voltage delta between min/max cell is too big, indicate voltage imbalance.
 * We schedule these by minimum cell voltage; use the corresponding threshold of the lowest voltage
 * greater than the minimum cell voltage.
 */
export interface BatteryCellVoltageImbalanceThresholds {
  cellVoltageImbalanceVoltageSchedule: number[];
  cellVoltageImbalanceThresholdSchedule: number[];
}

/**
 * Message that is saved to semi_persistent if DOCK_HEADING_MISMATCHED is triggered. This is
 * reloaded upon boot so that the fault persists.
 */
export interface LastDockHeadingEstimateMismatched {
  /** The last dock heading from sites. */
  siteHeading: number;
  /** Dock heading setup error detected in flight. */
  headingError: number;
}

function createBaseBatteryCellVoltageImbalanceThresholds(): BatteryCellVoltageImbalanceThresholds {
  return { cellVoltageImbalanceVoltageSchedule: [], cellVoltageImbalanceThresholdSchedule: [] };
}

export const BatteryCellVoltageImbalanceThresholds = {
  encode(message: BatteryCellVoltageImbalanceThresholds, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    writer.uint32(10).fork();
    for (const v of message.cellVoltageImbalanceVoltageSchedule) {
      writer.float(v);
    }
    writer.ldelim();
    writer.uint32(18).fork();
    for (const v of message.cellVoltageImbalanceThresholdSchedule) {
      writer.float(v);
    }
    writer.ldelim();
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BatteryCellVoltageImbalanceThresholds {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatteryCellVoltageImbalanceThresholds();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag === 13) {
            message.cellVoltageImbalanceVoltageSchedule.push(reader.float());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.cellVoltageImbalanceVoltageSchedule.push(reader.float());
            }

            continue;
          }

          break;
        case 2:
          if (tag === 21) {
            message.cellVoltageImbalanceThresholdSchedule.push(reader.float());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.cellVoltageImbalanceThresholdSchedule.push(reader.float());
            }

            continue;
          }

          break;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatteryCellVoltageImbalanceThresholds {
    return {
      cellVoltageImbalanceVoltageSchedule: globalThis.Array.isArray(object?.cellVoltageImbalanceVoltageSchedule)
        ? object.cellVoltageImbalanceVoltageSchedule.map((e: any) => globalThis.Number(e))
        : [],
      cellVoltageImbalanceThresholdSchedule: globalThis.Array.isArray(object?.cellVoltageImbalanceThresholdSchedule)
        ? object.cellVoltageImbalanceThresholdSchedule.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: BatteryCellVoltageImbalanceThresholds): unknown {
    const obj: any = {};
    if (message.cellVoltageImbalanceVoltageSchedule?.length) {
      obj.cellVoltageImbalanceVoltageSchedule = message.cellVoltageImbalanceVoltageSchedule;
    }
    if (message.cellVoltageImbalanceThresholdSchedule?.length) {
      obj.cellVoltageImbalanceThresholdSchedule = message.cellVoltageImbalanceThresholdSchedule;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BatteryCellVoltageImbalanceThresholds>, I>>(
    base?: I,
  ): BatteryCellVoltageImbalanceThresholds {
    return BatteryCellVoltageImbalanceThresholds.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BatteryCellVoltageImbalanceThresholds>, I>>(
    object: I,
  ): BatteryCellVoltageImbalanceThresholds {
    const message = createBaseBatteryCellVoltageImbalanceThresholds();
    message.cellVoltageImbalanceVoltageSchedule = object.cellVoltageImbalanceVoltageSchedule?.map((e) => e) || [];
    message.cellVoltageImbalanceThresholdSchedule = object.cellVoltageImbalanceThresholdSchedule?.map((e) => e) || [];
    return message;
  },
};

function createBaseLastDockHeadingEstimateMismatched(): LastDockHeadingEstimateMismatched {
  return { siteHeading: 0, headingError: 0 };
}

export const LastDockHeadingEstimateMismatched = {
  encode(message: LastDockHeadingEstimateMismatched, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.siteHeading !== 0) {
      writer.uint32(21).float(message.siteHeading);
    }
    if (message.headingError !== 0) {
      writer.uint32(29).float(message.headingError);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LastDockHeadingEstimateMismatched {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLastDockHeadingEstimateMismatched();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 21) {
            break;
          }

          message.siteHeading = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.headingError = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LastDockHeadingEstimateMismatched {
    return {
      siteHeading: isSet(object.siteHeading) ? globalThis.Number(object.siteHeading) : 0,
      headingError: isSet(object.headingError) ? globalThis.Number(object.headingError) : 0,
    };
  },

  toJSON(message: LastDockHeadingEstimateMismatched): unknown {
    const obj: any = {};
    if (message.siteHeading !== 0) {
      obj.siteHeading = message.siteHeading;
    }
    if (message.headingError !== 0) {
      obj.headingError = message.headingError;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LastDockHeadingEstimateMismatched>, I>>(
    base?: I,
  ): LastDockHeadingEstimateMismatched {
    return LastDockHeadingEstimateMismatched.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LastDockHeadingEstimateMismatched>, I>>(
    object: I,
  ): LastDockHeadingEstimateMismatched {
    const message = createBaseLastDockHeadingEstimateMismatched();
    message.siteHeading = object.siteHeading ?? 0;
    message.headingError = object.headingError ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
